import React from 'react';
import { WithChildren } from '../../../models/children-props';
import { IconsEnum } from '../../../constants/icons';
import { ButtonMenu } from '../../actions/ButtonMenu';
import classNames from 'classnames';

export type FilterDropdownViewProps = WithChildren & {
  breakPointClasses?: string | string[];
};

export const FilterDropdownView = (props: FilterDropdownViewProps): JSX.Element => {
  let breakPointClasses: string | undefined;
  if (typeof props.breakPointClasses === 'string') {
    breakPointClasses = props.breakPointClasses;
  } else if (Array.isArray(props.breakPointClasses)) {
    breakPointClasses = classNames(...props.breakPointClasses);
  }
  return (
    <div className={breakPointClasses ?? 'show-for-medium hide-for-xxlarge'}>
      <ButtonMenu
        isSquareButton={false}
        side={'left'}
        icon={IconsEnum.filter}
        dropdownMaximize={true}
        iconSide={'left'}
        elementType={'button'}
        label={'Filters'}
        size={'medium'}
        variantOnOpen={'solid'}
        variant={'hollow'}>
        {props.children}
      </ButtonMenu>
    </div>
  );
};
